import { SET_USERS_DATA_LOADING, SET_USERS, SET_SEARCH_USER_BY_ID } from "./types";
import store from "../../../../store";
import Axios from "../../../../common/util/Axios";

export const getUsers = (params) => async (dispatch) => {
  try {
    dispatch({ type: SET_USERS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;
    const queryParams = {
      ...params,
      companyId,
      branchId,
    };

    console.log('params : ', params);
    const res = await Axios.get(`/api/dashboard/users/find-users-with-keyword`, {
      params: queryParams,
    });

    console.log('res : ', res.data);
    dispatch({
      type: SET_USERS,
      payload: {
        data: res.data.data,
        pagination: res.data.pagination,
      },
    });
  } catch (err) {
    dispatch({
      type: SET_USERS,
      payload: {
        data: [],
        pagination: {
          currentPage: 1,
          totalPages: 1,
          totalRecords: 0,
          limit: 10,
          hasNextPage: false,
          hasPrevPage: false,
          nextPage: null,
          prevPage: null,
        },
      },
    });
  }
};

export const createUser = (requestBody) => async (dispatch) => {
  try {
    dispatch({ type: SET_USERS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;
    
    const queryParams = {
      companyId,
      branchId,
    };

    const res = await Axios.post(`/api/dashboard/users`, requestBody, {
      params: queryParams,
    });
    
    dispatch({ type: SET_USERS_DATA_LOADING, payload: false });
    return res.data.success;
  } catch (err) {
    dispatch({ type: SET_USERS_DATA_LOADING, payload: false });
    return false;
  }
};

export const findByUsername = (username) => async (dispatch) => {
  try {
    const companyId = store.getState().authState.companyId;
    
    const res = await Axios.get(`/api/dashboard/users/find-by`, {
      params: {
        companyId,
        username,
      },
    });
    
    return res.data.success && res.data.data !== null;
  } catch (err) {
    return false;
  }
};

export const getUserById = (userId) => async (dispatch) => {
  try {
    dispatch({ type: SET_USERS_DATA_LOADING, payload: true });
    
    const res = await Axios.get(`/api/dashboard/users/find-by-id`, {
      params: { id: userId },
    });
    
    dispatch({
      type: SET_SEARCH_USER_BY_ID,
      payload: res.data.success ? res.data.data : null,
    });
    dispatch({ type: SET_USERS_DATA_LOADING, payload: false });
    
    return res.data.success ? res.data.data : null;
  } catch (err) {
    dispatch({ type: SET_USERS_DATA_LOADING, payload: false });
    dispatch({ type: SET_SEARCH_USER_BY_ID, payload: null });
    return null;
  }
};

export const updateUser = (requestBody) => async (dispatch) => {
  try {
    dispatch({ type: SET_USERS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;
    
    const queryParams = {
      companyId,
      branchId,
    };

    const res = await Axios.put(`/api/dashboard/users`, requestBody, {
      params: queryParams,
    });
    
    dispatch({ type: SET_USERS_DATA_LOADING, payload: false });
    return res.data.success;
  } catch (err) {
    dispatch({ type: SET_USERS_DATA_LOADING, payload: false });
    return false;
  }
};

export const resetSearchedUser = () => (dispatch) => {
  dispatch({ type: SET_SEARCH_USER_BY_ID, payload: null });
};

